import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSuff',
})
export class ThousandSuffixesPipe implements PipeTransform {
  transform(input: any, args?: any, from?: 'PROFILE' | 'MODALS'): any {
    if (input === 0 && from === 'MODALS') {
      return 'Free';
    }
    var exp,
      rounded,
      suffixes = ['k', 'M', 'B', 'T', 'P', 'E'];

    if (Number.isNaN(input)) {
      return null;
    }

    if (input < 1000) {
      if (
        from === 'PROFILE' &&
        input.toString().split('.')[1] &&
        input.toString().split('.')[1].length > 3
      ) {
        return input.toFixed(2);
      } else return input;
    }
    exp = Math.floor(Math.log(input) / Math.log(1000));
    return (
      (Math.round(input) / Math.pow(1000, exp)).toFixed(args) +
      suffixes[exp - 1]
    );
  }
}
